module.exports = __webpack_public_path__ + "img/about_logo_30.1166efb2.png";